import { Color } from "../core/color/color";

export { LightTheme } from "./Light";
export { DarkTheme } from "./Dark";

export const colorTrechos = new Color(60, 151, 255);
export const colorMassasAgua = new Color(39, 115, 255);
export const colorPontoDeEstudo = new Color(14, 212, 0);
export const colorAreaDrenagem = new Color(128, 73, 0);
export const colorStrokeColor = Color.black;